import { render } from "./batch.vue?vue&type=template&id=4a6baa4e&scoped=true"
import script from "./batch.vue?vue&type=script&lang=js"
export * from "./batch.vue?vue&type=script&lang=js"

import "./batch.vue?vue&type=style&index=0&id=4a6baa4e&scoped=true&lang=css"

import exportComponent from "/drone/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a6baa4e"]])

export default __exports__